export default {
  reg: {
    letter: '只允许英文字母和空格'
  }
}
